// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var JsxRuntime = require("react/jsx-runtime");
var Utils$ReactHooksTemplate = require("../common/utils.res.js");
var TextInputNew$ReactHooksTemplate = require("../common/TextInputNew.res.js");
var StringCondition$ReactHooksTemplate = require("./StringCondition.res.js");
var MultipleTextInput$ReactHooksTemplate = require("../common/MultipleTextInput.res.js");

function StringConditionForm(props) {
  var updateCondition = props.updateCondition;
  var stringCondition = props.stringCondition;
  var operator = StringCondition$ReactHooksTemplate.operator(stringCondition);
  var showRhsField;
  switch (operator) {
    case "is_blank" :
    case "is_not_blank" :
        showRhsField = false;
        break;
    default:
      showRhsField = true;
  }
  var isSingleInput = operator === "equals" || operator === "not_equals";
  var rhs = StringCondition$ReactHooksTemplate.rhs(stringCondition);
  var availableOperators = StringCondition$ReactHooksTemplate.availableOperators();
  var handleOperatorChange = function ($$event) {
    var selectedOperator = Utils$ReactHooksTemplate.formTargetValue($$event);
    var updatedStringCondition = StringCondition$ReactHooksTemplate.setOperator(stringCondition, selectedOperator);
    Curry._1(updateCondition, {
          TAG: "StringCondition",
          _0: updatedStringCondition
        });
  };
  var handleSingleInputRhsChange = function ($$event) {
    var maxLength = StringCondition$ReactHooksTemplate.maximumLength(StringCondition$ReactHooksTemplate.lhs(stringCondition));
    var inputValue = Utils$ReactHooksTemplate.formTargetValue($$event);
    if (inputValue.length > maxLength) {
      return ;
    }
    var updatedStringCondition = StringCondition$ReactHooksTemplate.setRhs(stringCondition, {
          hd: inputValue,
          tl: /* [] */0
        });
    Curry._1(updateCondition, {
          TAG: "StringCondition",
          _0: updatedStringCondition
        });
  };
  var handleMultipleInputRhsChange = function (updatedTags) {
    var maxLength = StringCondition$ReactHooksTemplate.maximumLength(StringCondition$ReactHooksTemplate.lhs(stringCondition));
    var validTags = Belt_List.keep(updatedTags, (function (tag) {
            return tag.length <= maxLength;
          }));
    var updatedStringCondition = StringCondition$ReactHooksTemplate.setRhs(stringCondition, validTags);
    Curry._1(updateCondition, {
          TAG: "StringCondition",
          _0: updatedStringCondition
        });
  };
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: "Condition",
                              className: "w-48-px h-20-px font-normal text-xs text-aurometalsaurus "
                            }),
                        JsxRuntime.jsx("select", {
                              children: $$Array.of_list(Belt_List.map(availableOperators, (function (operator) {
                                          return JsxRuntime.jsx("option", {
                                                      children: StringCondition$ReactHooksTemplate.humanizeOperator(operator, stringCondition),
                                                      className: "text-left bg-white-300 px-2 py-1 hover:bg-gray-300",
                                                      value: operator
                                                    }, operator);
                                        }))),
                              className: "h-40-px px-2 py-1 rounded bg-white border border-gray-300\n                   cursor-pointer focus:border-gray-600 text-xs",
                              placeholder: "Select Operator",
                              value: operator,
                              onChange: handleOperatorChange
                            })
                      ],
                      className: "flex flex-col w-6/12"
                    }),
                showRhsField ? JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("div", {
                                children: "Answer",
                                className: "h-20-px font-normal text-xs text-aurometalsaurus "
                              }),
                          isSingleInput ? JsxRuntime.jsx(TextInputNew$ReactHooksTemplate.make, {
                                  label: "",
                                  value: rhs !== undefined && rhs ? rhs.hd : "",
                                  handleChange: handleSingleInputRhsChange,
                                  maxLength: StringCondition$ReactHooksTemplate.maximumLength(StringCondition$ReactHooksTemplate.lhs(stringCondition)),
                                  placeholder: "Enter Answer",
                                  textInputClassName: "h-40-px px-2 py-1 rounded bg-white border border-gray-300\n                            cursor-pointer focus:border-gray-600 text-xs w-full",
                                  inputBoxContainerCss: "flex flex-col w-full"
                                }) : JsxRuntime.jsx(MultipleTextInput$ReactHooksTemplate.make, {
                                  label: "",
                                  tags: rhs !== undefined ? Belt_List.map(rhs, (function (option) {
                                            return option;
                                          })) : /* [] */0,
                                  handleChange: handleMultipleInputRhsChange,
                                  labelCSS: "",
                                  containerClassName: "flex flex-col w-7/12"
                                })
                        ],
                        className: "flex flex-col w-8/12"
                      }) : JsxRuntime.jsx(JsxRuntime.Fragment, {})
              ],
              className: "flex gap-2 w-full"
            });
}

var make = StringConditionForm;

exports.make = make;
/* react/jsx-runtime Not a pure module */
